import axios from 'axios'

export const MAX_SECTION_EXPORT_SECONDS = 600
export const SECTION_EXPORT_POLL_INITIAL_MS = 5000
export const SECTION_EXPORT_POLL_MAX_MS = 30000
export const SECTION_EXPORT_POLL_DEADLINE_MS = 10 * 60 * 1000

const PROCESSING_STATUSES = new Set(['SUBMITTING', 'SUBMITTED', 'PROGRESSING'])

function exportsEndpoint(path = '') {
  const base = process.env.VUE_APP_BASE_URL || ''
  return `${base}/semantic-search/exports${path}`
}

export function isSectionExportPending(exportState) {
  return PROCESSING_STATUSES.has(String(exportState?.status || '').toUpperCase())
}

export function createSectionExport(ceremonyId, event) {
  const startSeconds = Number(
    event.cluster_start_sec ?? event.windowStartSeconds ?? event.timestamp
  )
  const endSeconds = Number(event.cluster_end_sec ?? event.windowEndSeconds)
  if (
    !Number.isFinite(startSeconds) ||
    !Number.isFinite(endSeconds) ||
    endSeconds <= startSeconds
  ) {
    throw new TypeError('This section does not have a valid time range.')
  }

  return axios.post(
    exportsEndpoint(),
    {
      ceremony_id: ceremonyId,
      section_id: String(event.id),
      label: String(event.title || 'Ceremony section'),
      start_seconds: startSeconds,
      end_seconds: endSeconds,
    },
    { timeout: 30000 }
  )
}

export function getSectionExport(exportId) {
  return axios.get(exportsEndpoint(`/${encodeURIComponent(exportId)}`), {
    timeout: 30000,
  })
}
